<template>
  <button class="notifications__notification-btn" :class="{'new': hasNew}" @click="openNotifications">
    <img
        src="@/assets/images/icons/notification-icon.svg"
        alt="Уведомления"
        class="notification-icon"
    />
    <span class="dot">{{ latestNotifications.newCount }}</span>
  </button>

  <NotificationBar
      v-if="!isMobile && showNotification"
      :show="showNotification"
      @close="showNotification = false"
  />

  <MobileNotification
      v-if="isMobile && showNotification"
      :show="showNotification"
      @close="showNotification = false"
  />
</template>

<script>
import { computed, onBeforeMount, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import {
  CloseOutlined, MoreOutlined, PlusOutlined, SettingOutlined, LeftOutlined, EditOutlined, DeleteOutlined,
  InfoCircleFilled
} from "@ant-design/icons-vue";

import Preloader from "../Technical/Preloader.vue";
import {onMounted} from "vue";
import useCheckRights from "@/mixins/useCheckRights";
import editOutlined from "@ant-design/icons-vue/lib/icons/EditOutlined";
import NotificationBar from "@/components/Notification/NotificationBar.vue";
import MobileNotification from "@/components/Notification/MobileNotificationBar.vue";
export default {
  methods: {editOutlined},
  components: {
    MobileNotification,
    NotificationBar,
    InfoCircleFilled,
    MoreOutlined, PlusOutlined, Preloader, CloseOutlined, SettingOutlined, LeftOutlined, DeleteOutlined, EditOutlined },
  name: "notification-window",
  emits: ['close'],
  setup(props, context) {
    const store = useStore();
    const latestNotifications = computed(
        () => store.state.notifications.latestNotifications
    );

    const {getRight} = useCheckRights();

    const isPreloader = ref(true);
    const hasNew = computed(() => latestNotifications.value.newCount);
    const showNotification = ref(false);

    const isMobile = ref(window.innerWidth <= 768)

    const onResize = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      window.addEventListener('resize', onResize)
    });

    onBeforeMount(async () => {
      fetchLatestNotifications();
    });

    const fetchLatestNotifications = () => {
      isPreloader.value = true;
      store.dispatch("notifications/getLatest")
          .then(() => (isPreloader.value = false));
    }

    const openNotifications = () => {
      showNotification.value = true;
      isPreloader.value = true;
    };

    return {
      openNotifications,
      latestNotifications,
      isPreloader,
      hasNew,
      showNotification,
      isMobile,
      getRight,
    };
  },
};
</script>

<style lang="scss">

.notification-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
  padding: 0;
}

.notifications {
  .popper {
    -webkit-box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.11) !important;
    -moz-box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.11) !important;
    box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.11) !important;
    color: var(--common-text-color) !important;

    &:hover {
      color: var(--common-text-color) !important;
    }

    #arrow::before,
    #arrow:hover::before {
      -webkit-box-shadow: 0px 5px 10px -3px rgba(34, 60, 80, 0.2);
      -moz-box-shadow: 0px 5px 10px -3px rgba(34, 60, 80, 0.2);
      box-shadow: 0px 5px 10px -3px rgba(34, 60, 80, 0.2);
    }
  }
}
</style>
<style lang="scss" scoped>
.notifications {
  &__notification-btn {
    position: relative;
    color: rgba(0, 0, 0, 0.5);
    display: flex;

    &:hover {
      color: rgba(0, 0, 0, 0.75);
    }
  }
}

.notifications__notification-btn.new {
  color: white;
}

.dot {
  display: none;
  position: absolute;
  top: -10px;
  right: -23px;
  height: 20px;
  min-width: 25px;
  background-color: var(--color-error);
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 4px;
  border: 1px solid #FFFFFF;
  border-radius: 999px;
  font-size: 14px;
}

.new .dot {
  display: flex;
}

@media (max-width: 768px) {
  .notifications-body {
    width: 300px;
  }
}

.inline-block {
  margin: 0 !important;
  border: 0 !important;
}

.notification-title {
  width: fit-content;
  position: relative;
  display: flex;
  align-items: center;
  column-gap: 8px;

  .dot {
    position: unset;
    color: #FFFFFF;
  }
}

.close-icon {
  color: var(--grey-text);
  cursor: pointer;
}

.close-icon:hover {
  color: var(--main-font);
}

.drawer-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tabs {
  width: fit-content;

  :deep(.ant-tabs-nav-more) {
    display: none;
  }
}

.spinner {
  margin-top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: $mobile-breakpoint) {
    margin-top: 10%;
  }
}

.date-header {
  font-weight: 400;
  font-size: 14px;
  line-height: 110%;
}

:deep(.ant-tabs-top >.ant-tabs-nav) {
  margin-bottom: 0 !important;
}

.recent {
  font-weight: 600;
}

.notice-card {
  padding: 12px 16px !important;
  box-shadow: unset;

  :deep(.ant-card-body) {
    padding: 0 !important;
    font-weight: 400;
    font-size: 14px;
  }

  .read-button-wrapper {
    @media (max-width: $mobile-breakpoint) {
      width: 100%;
    }
  }

  .read-button {
    @media (max-width: $mobile-breakpoint) {
      width: 100%;
    }
  }

  .notice-card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    @media (max-width: $mobile-breakpoint) {
      flex-direction: column;
      align-items: flex-start;

      .secondary-button {
        width: 100%;
      }
    }
  }
}

.new-notice {
  background-color: var(--polar-green);
}

:deep(.ant-tabs .ant-tabs-tab+.ant-tabs-tab) {
  margin-left: 16px !important;
}

.notice-card-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-button,
.footer-button-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.mobile-footer {
  flex-direction: column-reverse;

  button {
    width: 100%;
  }
}

.ant-dropdown-trigger.ant-dropdown-open {
  border-color: var(--main-green);
}

.empty-result {
  margin-top: 8px;
}

.sub-header {
  display: flex;
  column-gap: 12px;
  align-items: center;
}

.setting-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.settings-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.setting-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.setting-label {
  margin-bottom: 12px;
}

.setting-row {
  display: flex;
  column-gap: 8px;
  align-items: center;
}

.setting-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  margin-bottom: 16px;
}

.setting-card-block {
  :deep(.ant-card-body) {
    padding: 16px !important;
  }
}

.action-button-wrapper {
  cursor: pointer;
}

.notice-form {
  :deep(.ant-form-item) {
    margin-bottom: 12px !important;
  }

  :deep(.ant-form-item-label) {
    padding-bottom: 4px;

    label {
      color: var(--grey-text);
    }
  }
}

.blue-alert {
  border: unset;
  border-radius: 6px;

  :deep(.ant-alert-message) {
    padding: 8px 0;
  }
}

.control-button,
.footer-button .secondary-button.ant-dropdown-trigger {
    padding: 3px 9px;
}

.control-button-wrapper {
  display: flex;
  column-gap: 4px;
}

.footer-button {
  :deep(.ant-btn) {
    margin-inline-start: unset !important;
  }
}
</style>